<template>
  <div class="listbutton-wrapper">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.listbutton-wrapper {
  @apply tw-rounded-lg
  tw-bg-white
  tw-mb-2
  tw-py-5;
  border: 1px solid theme('colors.border.base');
}
</style>
